import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { fetchInventory, fetchExportedStores } from './api';
// import { FiSearch, FiPrinter } from 'react-icons/fi';
import { FiSearch} from 'react-icons/fi';
import Select from 'react-select';

import * as XLSX from 'xlsx';

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  width: 100%;
  height: calc(100vh - 120px);
  overflow: hidden;
  background-color: #f3f6fa;

  @media (max-width: 768px) {
    padding: 10px;
  }  
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  margin-top: -20px;
  
      @media (min-width: 1600px) {
    font-size: 12px;
    padding: 5px
  }

`;

const HeaderText = styled.h1`
  color: #1c4e8c;
  font-weight: bold;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 18px; /* Smaller for mobile */
        margin-top: -5px;
  }

  @media (max-width: 480px) {
    font-size: 14px; /* Even smaller for very small screens */
        margin-top: -5px;
  }
`;


const Input = styled.input`
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
   width: 120px;
  text-align: right;

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 5px;
  }  
`;


const SearchButton = styled.button`
  background: linear-gradient(135deg, #1c4e8c, #4a90e2);
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  transition: 0.3s;
  font-weight: bold;
  

  &:hover {
    background: linear-gradient(135deg, #164b7a, #367bc3);
    transform: scale(1.05);
  }

  svg {
    margin-left: 8px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    font-size: 10px;
    padding: 5px;
    margin-left: 0px;
  }  
`;


const ExportButton = styled.button`
  background: linear-gradient(135deg, #28a745, #58d68d);
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
  font-weight: bold;
  white-space: nowrap;

  svg {
    margin-left: 8px;
  }

  &:hover {
    background: linear-gradient(135deg, #1e7d32, #4caf50);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    font-size: 10px;
    padding: 5px 15px;

    svg {
      font-size: 14px;
      margin-bottom: 2px;
      margin-left: 0;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const PrintButton = styled.button`
  background: linear-gradient(135deg, #f39c12, #f4d03f);
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
  font-weight: bold;
  white-space: nowrap;

  svg {
    margin-left: 8px;
  }

  &:hover {
    background: linear-gradient(135deg, #d68910, #f1c40f);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    font-size: 10px;
    padding: 5px 15px;

    svg {
      font-size: 14px;
      margin-bottom: 2px;
      margin-left: 0;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const TableWrapper = styled.div`
  width: 95%;
  max-width: 1400px;
  max-height: 70vh;
  overflow-y: auto;
  background: white;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 20px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    max-height: 60vh;
  }  
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 9px;
  }  
`;

const Th = styled.th`
  background: #1c4e8c;
  color: white;
  padding: 18px;
  text-align: right;
  font-weight: bold;
  border-bottom: 3px solid #ddd;

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 9px;
  }  
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 15px;
  text-align: right;
  font-size: 16px;
  background-color: ${(props) => (props.index % 2 === 0 ? "#f9fbff" : "white")};
  transition: 0.3s;

  &:hover {
    background-color: #e3efff;
  }

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 9px;
  }  
`;

const Loading = styled.p`
  font-size: 18px;
  color: #1c4e8c;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 12px;
  }  
`;


const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  width: 95%;
  max-width: 1400px;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
    padding: 10px;
    margin-bottom: 10px;
  }  
`;

const FiltersToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: row;
    gap: 25px;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: row;
    gap: 5px;
  }
`;



const FiltersToggle = styled.button`
  background: #1c4e8c;
  color: white;
  border: none;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  transition: 0.3s;

  &:hover {
    background: #164b7a;
  }

  @media (min-width: 769px) {
    display: none; /* Hide toggle button on large screens */
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column; 
    margin-bottom: 0px;
    font-size: 10px;
    padding: 5px;
  }
`;



const FiltersWrapper = styled.div`
  width: 95%;
  display: flex;
  gap: 10px;
  flex-direction: column;

  /* 🖥️ Desktop - Always visible, default row layout */
  @media (min-width: 769px) {
    flex-direction: row;
    gap: 15px;
    opacity: 1;
    max-height: none;
    overflow: visible;
    transition: none;
  }

  /* 📱 Mobile - Toggle with animation */
  @media (max-width: 768px) {
    flex-direction: ${({ isVisible }) => (isVisible ? 'column-reverse' : 'column')};
    max-height: ${({ isVisible }) => (isVisible ? '500px' : '0')};
    opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.3s ease;
    gap: 8px;
  }
`;

const SummaryBox = styled.div`
  width: 95%;
  max-width: 1400px;
  background: #eaf6ff;
  color: #1c4e8c;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: right;
  border: 2px solid #1c4e8c;
  border-radius: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 10px;
  }
`;

const FilterItem = styled.div`
  display: flex;
  align-items: center;
  min-width: 150px;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;


const Inventory = () => {
  const { warehouseId } = useParams();
  const navigate = useNavigate();
  const [selectedWarehouse, setSelectedWarehouse] = useState(warehouseId || 'ALL');
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [minMakat, setMinMakat] = useState('');
  const [maxMakat, setMaxMakat] = useState('');
  const [searchText, setSearchText] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  // Export boats are not part of the login warehouse list, so they are fetched
  // separately - otherwise the dropdown and header can't resolve their name.
  const [exportedBoats, setExportedBoats] = useState([]);

  const userData = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {
    if (!userData) {
      navigate('/');
    }
  }, [userData, navigate]);

  useEffect(() => {
    if (userData?.Cust_Code) {
      fetchExportedStores(userData.Cust_Code).then((data) => setExportedBoats(data || []));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.Cust_Code]);

  // const loadInventory = useCallback(async (storeCode) => {
  //   setLoading(true);
  //   const data = await fetchInventory(storeCode, userData?.Cust_Code);
  
  //   // 🧠 Sort by numeric part of Makat ascending
  //   const sortedData = [...data].sort((a, b) => {
  //     const numA = parseInt(a.Makat.replace(/\D/g, ''), 10);
  //     const numB = parseInt(b.Makat.replace(/\D/g, ''), 10);
  //     return numA - numB;
  //   });
  
  //   setInventory(sortedData);
  //   setFilteredInventory(sortedData);
  //   setLoading(false);
  // }, [userData?.Cust_Code]);

  const loadInventory = useCallback(async (storeCode) => {
  setLoading(true);
  const data = await fetchInventory(storeCode, userData?.Cust_Code);
  const sortedData = [...data].sort((a, b) => {
    const numA = parseInt(a.Makat.replace(/\D/g, ''), 10);
    const numB = parseInt(b.Makat.replace(/\D/g, ''), 10);
    return numA - numB;
  });

    // 👇 extract unique customers
  const uniqueCustomers = [
    ...new Map(
      sortedData.map(item => [
        item.Cust_Code,
        { value: item.Cust_Code, label: item.Cust_Name }
      ])
    ).values()
  ];

  // 👇 add "ALL"
  setCustomerOptions([
    { value: '', label: 'הכל' },
    ...uniqueCustomers
  ]);

  // Save raw data and also pre-compute grouped version
  setInventory(sortedData);

  if (storeCode === "ALL_SUMMARIZED") {
    const grouped = Object.values(
      sortedData.reduce((acc, item) => {
        const key = item.Makat + "|" + item.Des;
        if (!acc[key]) {
          acc[key] = {
            Makat: item.Makat,
            Des: item.Des,
            Mlay: 0
          };
        }
        acc[key].Mlay += item.Mlay;
        return acc;
      }, {})
    );
    setFilteredInventory(grouped);
  } else {
    setFilteredInventory(sortedData);
  }

  setLoading(false);
}, [userData?.Cust_Code]);


  useEffect(() => {
    if (selectedWarehouse) {
      loadInventory(selectedWarehouse);
    }
  }, [selectedWarehouse, loadInventory]);

  const applyFilters = (customerOverride = null) => {
  const customerToUse = customerOverride ?? selectedCustomer;

  if (
    !minMakat &&
    !maxMakat &&
    !searchText &&
    (!customerToUse || !customerToUse.value)
  ) {
    loadInventory(selectedWarehouse);
    return;
  }

  let filteredData = [...inventory];

  if (minMakat && maxMakat) {
    filteredData = filteredData.filter(
      (item) => item.Makat >= minMakat && item.Makat <= maxMakat
    );
  }

  if (searchText) {
    filteredData = filteredData.filter((item) =>
      item.Des?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  if (customerToUse && customerToUse.value) {
    filteredData = filteredData.filter(
      item => item.Cust_Code === customerToUse.value
    );
  }

  filteredData.sort((a, b) => {
    const numA = parseInt(a.Makat.replace(/\D/g, ''), 10);
    const numB = parseInt(b.Makat.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  if (selectedWarehouse === "ALL_SUMMARIZED") {
    const grouped = Object.values(
      filteredData.reduce((acc, item) => {
        const key = item.Makat + "|" + item.Des;
        if (!acc[key]) {
          acc[key] = {
            Makat: item.Makat,
            Des: item.Des,
            Mlay: 0
          };
        }
        acc[key].Mlay += item.Mlay;
        return acc;
      }, {})
    );

    setFilteredInventory(grouped);
  } else {
    setFilteredInventory(filteredData);
  }
};

  // const applyFilters = () => {
  //   if (
  //     !minMakat &&
  //     !maxMakat &&
  //     !searchText &&
  //     (!selectedCustomer || !selectedCustomer.value)
  //   ) {
  //     loadInventory(selectedWarehouse);
  //     return;
  //   }

  //   let filteredData = [...inventory];

  //   if (minMakat && maxMakat) {
  //     filteredData = filteredData.filter(
  //       (item) => item.Makat >= minMakat && item.Makat <= maxMakat
  //     );
  //   }

  //   if (searchText) {
  //     filteredData = filteredData.filter((item) =>
  //       item.Des.includes(searchText)
  //     );
  //   }

  //   //console.log("🔍 Before sorting by Makat:", filteredData.map(i => i.Makat));

  //   filteredData.sort((a, b) => {
  //     const numA = parseInt(a.Makat.replace(/\D/g, ''), 10);
  //     const numB = parseInt(b.Makat.replace(/\D/g, ''), 10);
  //     return numA - numB;
  //   });
    
  //   //console.log("✅ After sorting by Makat descending:", filteredData.map(i => i.Makat));
    

  //   if (selectedCustomer && selectedCustomer.value) {
  //     filteredData = filteredData.filter(
  //       item => item.Cust_Code === selectedCustomer.value
  //     );
  //   }

  //     // 🧪 If in "ALL_SUMMARIZED" mode → group by Makat + Des
  //   if (selectedWarehouse === "ALL_SUMMARIZED") {
  //     const grouped = Object.values(
  //       filteredData.reduce((acc, item) => {
  //         const key = item.Makat + "|" + item.Des;
  //         if (!acc[key]) {
  //           acc[key] = {
  //             Makat: item.Makat,
  //             Des: item.Des,
  //             Mlay: 0
  //           };
  //         }
  //         acc[key].Mlay += item.Mlay;
  //         return acc;
  //       }, {})
  //     );

  //     setFilteredInventory(grouped);
  //   } else {
  //     setFilteredInventory(filteredData);
  //   }

  // };

  const exportToExcel = () => {
  if (filteredInventory.length === 0) {
    alert("אין נתונים לייצוא");
    return;
  }

  let formattedData = [];
  let headers = {};
  let fileName = "";
  const now = new Date();
  const formattedDate = now.toISOString().replace(/T/, '_').replace(/:/g, '-').split('.')[0];
  const warehouseLabel = selectedWarehouse === "ALL" ? "הכל" :
                         selectedWarehouse === "ALL_SUMMARIZED" ? "הכל_מסוכם" :
                         selectedWarehouse;

  if (selectedWarehouse === "ALL_SUMMARIZED") {
    headers = {
      Mlay: "כמות כוללת",
      Des: "שם פריט",
      Makat: "מק״ט",
    };

    formattedData = filteredInventory.map(item => ({
      [headers.Mlay]: item.Mlay,
      [headers.Des]: item.Des,
      [headers.Makat]: item.Makat,
    }));

    const total = filteredInventory.reduce((sum, item) => sum + item.Mlay, 0);

    formattedData.push({
      [headers.Mlay]: total,
      [headers.Des]: "סה״כ כלל הפריטים",
      [headers.Makat]: '',
    });
  } else {
    headers = {
      Mlay: "כמות",
      Des: "שם פריט",
      Makat: "מק״ט",
      Store_Name: "שם אוניה",
      Store_Code: "קוד אוניה",
      Cust_Name: "שם לקוח",
      Cust_Code: "קוד לקוח",
    };

    formattedData = filteredInventory.map((item) => ({
      [headers.Mlay]: item.Mlay,
      [headers.Des]: item.Des,
      [headers.Makat]: item.Makat,
      [headers.Store_Name]: item.Store_Name,
      [headers.Store_Code]: item.Store_Code,
      [headers.Cust_Name]: item.Cust_Name,
      [headers.Cust_Code]: item.Cust_Code,
    }));

    const total = filteredInventory.reduce((sum, item) => sum + item.Mlay, 0);

    formattedData.push({
      [headers.Mlay]: total,
      [headers.Des]: "סה״כ כלל הפריטים",
      [headers.Makat]: '',
      [headers.Store_Name]: '',
      [headers.Store_Code]: '',
      [headers.Cust_Name]: '',
      [headers.Cust_Code]: '',
    });
  }

  const ws = XLSX.utils.json_to_sheet(formattedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Inventory");

  fileName = `inventory_${warehouseLabel}_${formattedDate}.xlsx`;

  XLSX.writeFile(wb, fileName);
};


const printTable = () => {
  const table = document.getElementById("inventoryTable");
  if (!table) return;

  const totalQuantity = filteredInventory.reduce((sum, item) => sum + (item.Mlay || 0), 0);

  // Clone the table
  const clonedTable = table.cloneNode(true);

  // Add total row
  const totalRow = clonedTable.insertRow();
  totalRow.style.fontWeight = "bold";
  const totalCell = totalRow.insertCell(0);
  totalCell.colSpan = selectedWarehouse === "ALL_SUMMARIZED" ? 3 : 7;
  totalCell.textContent = `סה״כ כלל הפריטים: ${totalQuantity}`;

  // Print logic
  const newWindow = window.open("", "_blank");
  newWindow.document.write(`
    <html>
      <head>
        <title>הדפסת מלאי</title>
        <style>
          body { font-family: Arial, sans-serif; direction: rtl; text-align: right; padding: 20px; }
          table { width: 100%; border-collapse: collapse; font-size: 16px; }
          th, td { border: 1px solid black; padding: 10px; text-align: right; }
          th { background: #1c4e8c; color: white; }
          tr:last-child td { font-weight: bold; background-color: #f0f0f0; }
        </style>
      </head>
      <body>
        <h2>מלאי עבור ${selectedWarehouse === "ALL" ? "הכל" : selectedWarehouse === "ALL_SUMMARIZED" ? "הכל מסוכם" : selectedWarehouse}</h2>
        ${clonedTable.outerHTML}
        <script>
          window.onload = function() {
            window.print();
            setTimeout(() => window.close(), 500);
          };
        </script>
      </body>
    </html>
  `);
  newWindow.document.close();
};


  
  

  const warehouses = userData?.Warehouses || [];

const itemCategoryOptions = [
  { value: '', label: 'הכל' }, 
  { value: 'סלילים מצולעים', label: 'סלילים מצולעים' },
  { value: 'ברזל בניין', label: 'ברזל בניין' },
  { value: 'גלילי פח', label: 'גלילי פח' },
  { value: 'סלילים חלקים', label: 'סלילים חלקים' },
];

const handleCategoryChange = (selectedOption) => {
  if (!selectedOption || selectedOption.value === '') {
    setSearchText('');
    setFilteredInventory(inventory); // 🔥 reset everything
    return;
  }

  let value = selectedOption.value;

  // 🔥 Default: keep your working logic
  let newSearchText = value;

  if (value === 'סלילים חלקים') {
    newSearchText = 'סליל';

    // 🔥 Filter ONLY GDW (חלקים)
    const filtered = inventory.filter(item =>
      item.Makat?.includes('GDW')
    );

    setFilteredInventory(filtered);

  } else if (value === 'סלילים מצולעים') {
    newSearchText = 'מצולע';

    // 🔥 Filter ONLY GDB (מצולעים)
    const filtered = inventory.filter(item =>
      item.Makat?.includes('GDB')
    );

    setFilteredInventory(filtered);

  } else {
    // 🔥 For the others → just use text (like today)
    const filtered = inventory.filter(item =>
      item.Des?.includes(value)
    );

    setFilteredInventory(filtered);
  }

  setSearchText(newSearchText);
};


  // export boats that aren't already in the regular warehouse list
  const exportOnly = exportedBoats.filter(
    b => !warehouses.some(w => String(w.Store_Code) === String(b.Store_Code))
  );

  const options = [
  { value: 'ALL', label: 'הכל' },
  { value: 'ALL_SUMMARIZED', label: 'הכל מסוכם' }, // 👈 new option
  ...warehouses.map(w => ({
    value: w.Store_Code,
    label: `${w.Store_Name} (${w.Store_Code})`,
  })),
  ...exportOnly.map(b => ({
    value: b.Store_Code,
    label: `📦 ${b.Store_Name} (${b.Store_Code})`,
  }))
];

  const selectedBoat = exportedBoats.find(b => String(b.Store_Code) === String(selectedWarehouse));
  const selectedOption = options.find(opt => opt.value === selectedWarehouse);

  // 👇 dynamic styling for react-select
  const customStyles = {
    control: (base, state) => ({
      ...base,
      padding: '2px',
      fontSize: window.innerWidth < 768 ? '10px' : '16px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      backgroundColor: 'white',
      cursor: 'pointer',
       width: '100%',
      textAlign: 'right',
      direction: 'rtl',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
      '&:hover': {
        borderColor: '#888'
      }
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      fontSize: window.innerWidth < 768 ? '10px' : '16px',
      direction: 'rtl',
      textAlign: 'right',
      maxHeight: window.innerWidth < 768 ? '300px' : 'auto',
      overflowY: 'auto',
      position: 'absolute',
      width: '100%' // Optional: make it match the select width
    }),
    
    singleValue: (base) => ({
      ...base,
      direction: 'rtl',
      textAlign: 'right'
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#eee' : 'white',
      color: 'black',
      cursor: 'pointer',
      fontSize: window.innerWidth < 768 ? '10px' : '16px',
      direction: 'rtl',
      textAlign: 'right'
    }),
  };

  return (
    <Container>

        <HeaderContainer>
          <HeaderText>
            {selectedWarehouse === 'ALL_SUMMARIZED'
              ? 'מלאי מסוכם עבור כל האוניות'
              : selectedBoat
                ? `מלאי עבור אוניית יצוא ${selectedBoat.Store_Name} (${selectedBoat.Store_Code})${selectedBoat.ExportedDate ? ' - יצאה' : ''}`
                : `מלאי עבור אוניה ${selectedWarehouse === 'ALL' ? 'הכל' : selectedWarehouse}`}
          </HeaderText>
        </HeaderContainer>


        <FiltersContainer>
  {/* 🟢 Top Row: Filter Toggle, Export & Print Buttons (on mobile) */}
  <FiltersToggleRow>
    {/* 📂 Print & Export Buttons Move to Top Row on Mobile */}
    {!showFilters && (
      <ButtonsWrapper>
        <ExportButton onClick={exportToExcel}> 📥 <span>יצוא לאקסל</span></ExportButton>
        <PrintButton onClick={printTable}>🖨️ הדפס</PrintButton>
      </ButtonsWrapper>
    )}

<FiltersToggle onClick={() => setShowFilters(!showFilters)}>
  {showFilters ? (
    <>
      🔽 <span>הסתר מסננים</span>
    </>
  ) : (
    <>
      🔼 <span>הצג מסננים</span>
    </>
  )}
</FiltersToggle>
  </FiltersToggleRow>

  {/* 🟢 Filter Inputs - Hidden by Default on Mobile */}
  <FiltersWrapper isVisible={showFilters}>

        {/* 🔹 Buttons Show Here on Larger Screens */}
        {showFilters && (
      <ButtonsWrapper>
        <ExportButton onClick={exportToExcel}> 📥 <span>יצוא לאקסל</span></ExportButton>
        <PrintButton onClick={printTable}>🖨️ <span>הדפס</span></PrintButton>
      </ButtonsWrapper>
    )}
    
    <SearchButton onClick={applyFilters}>
      <FiSearch size={18} /> חפש
    </SearchButton>

    <FilterItem>
      <Select
        options={options}
        value={selectedOption}
        onChange={(opt) => setSelectedWarehouse(opt.value)}
        styles={{
          ...customStyles,
          menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ⬅️ Add this
        }}
        menuPortalTarget={document.body} // ⬅️ Super important
        placeholder="בחר מחסן"
      />
    </FilterItem>

    

      <FilterItem>
  <Select
    options={customerOptions}
    value={selectedCustomer}
    onChange={(option) => {
      setSelectedCustomer(option);
      applyFilters(option); // 👈 pass fresh value
    }}
    styles={{
      ...customStyles,
      menuPortal: (base) => ({ ...base, zIndex: 9999 })
    }}
    menuPortalTarget={document.body}
    placeholder="לקוח"
  />
</FilterItem>



    <Input type="text" placeholder="מקט מינימלי" value={minMakat} onChange={(e) => setMinMakat(e.target.value)} />
    <Input type="text" placeholder="מקט מקסימלי" value={maxMakat} onChange={(e) => setMaxMakat(e.target.value)} />
    <FilterItem>

    <Select
  options={itemCategoryOptions}
  onChange={handleCategoryChange}
  styles={{
    ...customStyles,
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  }}
  menuPortalTarget={document.body}
  placeholder="  פריטים"
/>
    </FilterItem>

    


    <Input type="text" placeholder="🔍 חיפוש פריט" value={searchText} onChange={(e) => setSearchText(e.target.value)} />

  </FiltersWrapper>
</FiltersContainer>


      {loading ? (
        <Loading>טוען מלאי...</Loading>

      ) : (
        <TableWrapper>

          <Table id="inventoryTable">
            <thead>
              <tr>
                {selectedWarehouse === 'ALL_SUMMARIZED' ? (
                  <>
                    <Th>כמות כוללת</Th>
                    <Th>שם פריט</Th>
                    <Th>מק"ט</Th>
                  </>
                ) : (
                  <>
                    <Th>כמות</Th>
                    <Th>שם פריט</Th>
                    <Th>מק"ט</Th>
                    <Th>שם אוניה</Th>
                    <Th>קוד אוניה</Th>
                    <Th>שם לקוח</Th>
                    <Th>קוד לקוח</Th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {filteredInventory.map((item, index) => (
                <tr key={index}>
                  <Td>{item.Mlay}</Td>
                  <Td>{item.Des}</Td>
                  <Td>{item.Makat}</Td>
                  {selectedWarehouse !== 'ALL_SUMMARIZED' && (
                    <>
                      <Td>{item.Store_Name}</Td>
                      <Td>{item.Store_Code}</Td>
                      <Td>{item.Cust_Name}</Td>
                      <Td>{item.Cust_Code}</Td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>

        </TableWrapper>
        
      )}
            <SummaryBox>
  סה"כ כמות כללית: {filteredInventory.reduce((acc, item) => acc + (item.Mlay || 0), 0)}
</SummaryBox>

    </Container>
  );
};

export default Inventory;

